@if (updatedRequirementsTableDesign) {
<div class="updated-notes-panel">

  <!-- <div class="mt-1 mb-1">
    <mat-chip-listbox multiple="true">
      <mat-chip-option [selected]="allSelected" (selectionChange)="toggleNoteFilter('all', $event)">All</mat-chip-option>
      <mat-chip-option [selected]="manualSelected" (selectionChange)="toggleNoteFilter('manual', $event)">Manual</mat-chip-option>
      <mat-chip-option [selected]="agentCommunicationSelected" (selectionChange)="toggleNoteFilter('agentCommunication', $event)">Agent Communication</mat-chip-option>
      <mat-chip-option [selected]="requirementStatusSelected" (selectionChange)="toggleNoteFilter('requirementStatus', $event)">Requirement Status</mat-chip-option>
      <mat-chip-option [selected]="evidenceUpdateSelected" (selectionChange)="toggleNoteFilter('evidenceUpdate', $event)">Evidence Update</mat-chip-option>
      <mat-chip-option [selected]="documentSelected" (selectionChange)="toggleNoteFilter('document', $event)">Document</mat-chip-option>
    </mat-chip-listbox>
  </div> -->

  <ul #notesList class="requirement-notes-list">
    <li *ngIf="notes.length == 0">No Notes Added</li>
    <li *ngFor="let note of notes" class="requirement-note">
      <div class="details">
        <div class="d-flex flex-row justify-content-between" *ngIf="editingNoteId !== note.id">
          <div class="unread-marker" *ngIf="showUnreadIcon(note) && !note.isReviewed">
            <span *ngIf="showUnreadIcon(note) && !note.isReviewed"></span>
          </div>
          <span class="note-type-label">{{ isAgentCommunicationNote(note) ? 'Agent Communication' : 'Note'}}</span>
          <div class="unread-marker-actions">
            <button mat-icon-button class="mat-mdc-note-icon-button" *ngIf="showUnreadIcon(note)"
              [matTooltip]="note.isReviewed ? 'Read' : 'Mark as Read'" matTooltipPosition="above"
              (click)="markNoteAsReviewed(note)">
              <mat-icon fontSet="material-symbols-outlined">
                <ng-container *ngIf="!note.isReviewed">drafts</ng-container>
                <ng-container *ngIf="note.isReviewed">mark_email_read</ng-container>
              </mat-icon>
            </button>
            <button mat-icon-button class="mat-mdc-note-icon-button"
              *ngIf="isHiddenNoteFeatureEnabled && isHiddenNoteAccountSettingEnabled"
              [matTooltip]="note.isInternalNote ? 'Hidden on case document' : 'Visible on case document'"
              matTooltipPosition="above" (click)="toggleNoteVisibility(note.id)" [disabled]="baseProps?.readonly">
              <mat-icon>
                <ng-container *ngIf="!note.isInternalNote">visibility</ng-container>
                <ng-container *ngIf="note.isInternalNote">visibility_off</ng-container>
              </mat-icon>
            </button>
          </div>
          <button class="btn btn-link btn-sm flex-shrink-0 custom" style="font-size: 14px !important"
            *ngIf="canEditNote(note)" (click)="editNote(note)" [disabled]="disableEditNote(note)">Edit</button>
        </div>
        @if (updatedRequirementTaskNoteStyling) {
          <div class="requirement-name" *ngIf="showRequirementHandle && note.caseRequirementNote?.caseRequirementName">
            Requirement: {{ note.caseRequirementNote?.caseRequirementName }}<ng-container
              *ngIf="note.caseRequirementNote?.caseRequirementSubtitle">: {{
              note.caseRequirementNote?.caseRequirementSubtitle }}</ng-container>
          </div>
            <div class="requirement-name" *ngIf="note.caseTaskNote">Task: {{ note.caseTaskNote?.taskName }}
            <ng-container
                *ngIf="note.caseTaskNote?.subtitle">: {{
                note.caseTaskNote?.subtitle }}</ng-container>

            </div>
        }
        <div class="message flex-grow-1" 
          [class.message-condensed]="updatedRequirementTaskNoteStyling && !isNoteExpanded(note.id)"
          [id]="'message-' + note.id" [innerHtml]="note.message"></div>
        @if (updatedRequirementTaskNoteStyling) {
          <div class="note-expand-link" [id]="'expand-' + note.id" style="display: none;">
            <a class="btn-link-more" (click)="toggleNoteExpanded(note.id)">
              <mat-icon svgIcon="plus" *ngIf="!isNoteExpanded(note.id)"></mat-icon>
              <mat-icon svgIcon="minus" *ngIf="isNoteExpanded(note.id)"></mat-icon>
              {{ isNoteExpanded(note.id) ? 'See Less' : 'See More' }}
            </a>
          </div>
        }
        <div class="d-flex flex-row justify-content-between align-items-center note-meta mt-1">
          <div>
            <span class="note-author">{{ note.userDisplayName }}</span>
            <span class="note-role">{{ note.userRole }}</span>
          </div>
          <span class="note-date">{{ note.updatedOnDisplay || note.createdOnDisplay }}</span>
        </div>

        <!-- TODO Where do subtitles go??
      <div class="requirement-name" *ngIf="showRequirementHandle">
          {{ note.caseRequirementNote?.caseRequirementName }}<ng-container *ngIf="note.caseRequirementNote?.caseRequirementSubtitle">: {{  note.caseRequirementNote?.caseRequirementSubtitle }}</ng-container>
        </div> -->


        <div class="d-flex flex-row justify-content-between" *ngIf="editingNoteId === note.id">
          <app-rich-text-editor [(ngModel)]="editedMessage" placeholder="Edit note..." minHeight="100px" class="configuration-editor"
            [attr.data-note-id]="note.id">
          </app-rich-text-editor>
          <div id="divEditNoteButtons" class="action-button-container" style="flex: 0 0 0 !important">
            <ng-container>
              <button mat-flat-button style="background-color: transparent" (click)="discardEdit()">Discard</button>
              <button mat-stroked-button color="primary" (click)="saveNote(note)">Save</button>
            </ng-container>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
}
@else {
<ul #notesList class="notes-list">
  <li *ngIf="notes.length == 0" class="no-note-message">No Notes Added</li>
  <li *ngFor="let note of notes" class="note">
    <div class="unread-marker">
      <span *ngIf="showUnreadIcon(note) && !note.isReviewed"></span>
    </div>
    <ul class="details">
      <li class="detail note-name">
        {{ isAgentCommunicationNote(note) ? 'Agent Communication' : note.userDisplayName}}
      </li>
      <li class="detail note-info">{{ isAgentCommunicationNote(note) ? note.userDisplayName : note.userRole }}</li>
      <li class="detail note-info">{{ note.updatedOnDisplay || note.createdOnDisplay }}</li>
    </ul>
    <div class="note-content">
      <div class="requirement-name" *ngIf="showRequirementHandle">
        {{ note.caseRequirementNote?.caseRequirementName }}<ng-container
          *ngIf="note.caseRequirementNote?.caseRequirementSubtitle">: {{
          note.caseRequirementNote?.caseRequirementSubtitle }}</ng-container>
      </div>
      <div class="message" *ngIf="editingNoteId !== note.id" [innerHtml]="note.message"></div>
      <div *ngIf="editingNoteId === note.id">
        <mat-form-field class="text-area-container textarea-formfield">
          <textarea #editNoteTextArea [attr.data-note-id]="note.id" matInput [(ngModel)]="editedMessage"
            cdkTextareaAutosize cdkAutosizeMaxRows="10"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div id="divEditNoteButtons" class="action-button-container">
      <button mat-stroked-button color="primary" *ngIf="canEditNote(note)" (click)="editNote(note)"
        [disabled]="disableEditNote(note)">Edit Note</button>
      <ng-container *ngIf="editingNoteId === note.id">
        <button mat-flat-button style="background-color: transparent" (click)="discardEdit()">Discard</button>
        <button mat-stroked-button color="primary" (click)="saveNote(note)">Save Note</button>
      </ng-container>
    </div>
    <button mat-icon-button class="mat-mdc-note-icon-button" *ngIf="showUnreadIcon(note)"
      [matTooltip]="note.isReviewed ? 'Read' : 'Mark as Read'" matTooltipPosition="above"
      (click)="markNoteAsReviewed(note)">
      <mat-icon fontSet="material-symbols-outlined">
        <ng-container *ngIf="!note.isReviewed">drafts</ng-container>
        <ng-container *ngIf="note.isReviewed">mark_email_read</ng-container>
      </mat-icon>
    </button>
    <button mat-icon-button class="mat-mdc-note-icon-button"
      *ngIf="isHiddenNoteFeatureEnabled && isHiddenNoteAccountSettingEnabled"
      [matTooltip]="note.isInternalNote ? 'Hidden on case document' : 'Visible on case document'"
      matTooltipPosition="above" (click)="toggleNoteVisibility(note.id)" [disabled]="baseProps?.readonly">
      <mat-icon>
        <ng-container *ngIf="!note.isInternalNote">visibility</ng-container>
        <ng-container *ngIf="note.isInternalNote">visibility_off</ng-container>
      </mat-icon>
    </button>
  </li>
</ul>
}